<template>
  <page-section
    id="registration-status"
    :title="$t('cac.app.registration_status')"
    class="voter-info__page-section"
  >
    <p
      :class="messageClass"
      class="registration-status__message"
    >
      <icon
        :icon-name="icon"
        view-box="0 0 24 24"
      />
      <span>{{ message }}</span>
    </p>
    <p v-if="address">{{ pollingAddress }}</p>
  </page-section>
</template>

<script>
import Icon from "StyleguideComponents/Icon.vue";
import { CHECK, X } from "Constants/styleguide/iconNames";

import PageSection from "CivicActionCenterComponents/shared/PageSection.vue";

export default {
  name: "RegistrationStatus",
  components: {
    Icon,
    PageSection
  },
  props: {
    address: {
      type: String,
      required: true
    },
    registered: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    window.dispatchEvent(new Event('resize'));
  },
  computed: {
    icon() {
      return this.registered ? CHECK : X;
    },
    message() {
      if (this.registered) {
        return this.$t("cac.app.you_are_registered_to_vote");
      }
      return this.$t("cac.app.you_are_not_registered_to_vote");
    },
    registrationStatus() {
      // TODO: Use constants for "success" and "failed" instead of just raw Strings
      return this.registered ? "success" : "failed";
    },
    messageClass() {
      return `registration-status__message--${this.registrationStatus}`;
    },
    pollingAddress() {
      return `${this.$t("cac.app.registered_at")} ${this.address}`;
    }
  }
};
</script>
